import { ConfigProvider } from 'antd';
import { RouterProvider } from 'react-router-dom';
import { observer } from 'mobx-react';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { StoreProvider, rootStore } from '@/stores';
import { antdLightTheme, antdDarkTheme } from '@/theme/antd';
import { reactPlugin } from '@/lib/telemetry';
import { router } from '@/routes/routes';
import { ErrorBoundary } from '@/components/ErrorBoundary';

// ThemedShell observes ThemeStore so dark/light switching is reactive.
const ThemedShell = observer(function ThemedShell() {
  const mode = rootStore.themeStore.mode;
  // Toggle a body class so plain CSS (globals.css) can adapt scrollbars / bg.
  if (typeof document !== 'undefined') {
    document.documentElement.dataset.theme = mode;
  }
  return (
    <ConfigProvider theme={mode === 'dark' ? antdDarkTheme : antdLightTheme}>
      <RouterProvider router={router} />
    </ConfigProvider>
  );
});

export function App() {
  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      <StoreProvider>
        <ErrorBoundary>
          <ThemedShell />
        </ErrorBoundary>
      </StoreProvider>
    </AppInsightsContext.Provider>
  );
}
